export var DEPLOY_DATE = new Date('2026-03-10T14:34:40+0000');
